var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',{attrs:{"title":_vm.$t('widgeterShops.title'),"subtitle":_vm.$t('widgeterShops.subtitle')}}),_c('Filters',{ref:"Filters"}),_c('Results',{ref:"Results"}),_c('ModalProductFeeds')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }